export default {
  form: {
    owner_phone_number: {
      label: 'Numéro de téléphone du contact',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'E-mail du contact',
      placeholder: "Saisir l'e-mail",
    },
    owner_first_name: {
      label: 'Prénom',
      placeholder: 'Saisir le prénom',
    },
    owner_last_name: {
      label: 'Nom',
      placeholder: 'Saisir le nom',
    },
    owner_dob: {
      label: 'Date de naissance',
      placeholder: 'Date',
    },
    owner_id_number: {
      label: "Numéro d'identification (ex. numéro de sécurité sociale)",
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Retour',
    next: 'Suivant',
  },
};
